import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';
import AddLocationModal from './AddLocationModal';
import RatingModal from './RatingModal';
import CommentsModal from './CommentsModal';
import RedirectToRegisterModal from './RedirectToRegisterModal';
import AuthModal from './AuthModal';
import SunriseAnimation from './SunriseAnimation';
import SpecialOfferModal from './SpecialOfferModal';
// import AdminOfferMenu from './AdminOfferMenu'; // DEPRECATED - Using unified SpecialOfferModal flow
import SpecialOfferForm from './SpecialOfferForm';
import OfferListManagement from './OfferListManagement';
import BusinessTemplateEditor from './BusinessTemplateEditor';
import { BACKEND_URL, API_BASE } from '../config/api';
import analyticsTracker from '../utils/analyticsTracker';

const API = API_BASE;

// Embedded base64 paw icon to avoid CORS issues in SVG data URLs
const PAW_ICON_BASE64 = 'data:image/png;base64,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';

// Pin type color configuration for admin business pins
const PIN_TYPE_CONFIG = {
  standard: { color: '#10B981', label: 'Standard Location', emoji: '🐾' },        // emerald-500 - User locations
  cafe: { color: '#8B4513', label: 'Café', emoji: '☕' },                         // brown - Coffee shops
  bar: { color: '#6B46C1', label: 'Bar', emoji: '🍷' },                           // purple - Bars/pubs
  vet: { color: '#DC2626', label: 'Vet', emoji: '➕' },                           // red - Veterinary clinics
  dog_food: { color: '#F97316', label: 'Dog Food', emoji: '🥣' },                 // orange - Pet food stores
  grooming: { color: '#EC4899', label: 'Grooming', emoji: '✂' },                  // pink - Grooming services
  accessories: { color: '#FBBF24', label: 'Accessories', emoji: '🎾' },           // yellow - Pet accessories
  dog_shelter: { color: '#78716C', label: 'Dog Shelter', emoji: '🏠' },           // gray-brown - Shelters/rescues
  daycare: { color: '#14B8A6', label: 'Daycare', emoji: '☀️' }                    // teal - Doggy daycare
};

// Function to get pin color based on category
const getPinColor = (category) => {
  return PIN_TYPE_CONFIG[category]?.color || PIN_TYPE_CONFIG.standard.color;
};

// Function to get pin emoji based on category
const getPinEmoji = (category) => {
  return PIN_TYPE_CONFIG[category]?.emoji || PIN_TYPE_CONFIG.standard.emoji;
};

const MapPage = () => {
  const { isAuthenticated, user } = useAuth();
  const mapContainerRef = useRef(null);
  const [map, setMap] = useState(null);
  const [apiKey, setApiKey] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [userLocation, setUserLocation] = useState(null);
  const [dogParks, setDogParks] = useState([]);
  const [specialOffers, setSpecialOffers] = useState([]); // Active special offers
  const [searchQuery, setSearchQuery] = useState('');
  const [showAddLocationModal, setShowAddLocationModal] = useState(false);
  const [showRatingModal, setShowRatingModal] = useState(false);
  const [selectedParkForRating, setSelectedParkForRating] = useState(null);
  const [showRatings, setShowRatings] = useState(false); // Toggle for star ratings
  const showRatingsRef = useRef(false); // Ref to access current value in closures
  const [showCommentsModal, setShowCommentsModal] = useState(false);
  const [selectedParkForComments, setSelectedParkForComments] = useState(null);
  const [showRedirectModal, setShowRedirectModal] = useState(false); // New: Redirect to register modal
  
  // Special Offers states
  const [showOfferModal, setShowOfferModal] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);
  // const [showAdminOfferMenu, setShowAdminOfferMenu] = useState(false); // DEPRECATED - Using unified flow
  const [selectedParkForOffer, setSelectedParkForOffer] = useState(null);
  const [showOfferForm, setShowOfferForm] = useState(false);
  const [showOfferManagement, setShowOfferManagement] = useState(false);
  const [showBusinessTemplateEditor, setShowBusinessTemplateEditor] = useState(false);
  const [selectedBusinessPark, setSelectedBusinessPark] = useState(null);
  const [showFilterModal, setShowFilterModal] = useState(false); // Amenities filter modal
  const [selectedAmenities, setSelectedAmenities] = useState([]); // Selected amenities for filtering
  const markersRef = useRef([]);
  const ratingOverlaysRef = useRef([]); // Store rating popup overlays
  const infoWindowRef = useRef(null);
  const initializationAttempted = useRef(false);
  const initMapFunctionRef = useRef(null);
  const searchInputRef = useRef(null);
  const autocompleteRef = useRef(null);

  // Available amenities (same as AddLocationModal)
  const availableAmenities = [
    { name: 'Parking', icon: '🅿️' },
    { name: 'Water Fountain', icon: '💧' },
    { name: 'Fenced Area', icon: '🚧' },
    { name: 'Benches', icon: '🪑' },
    { name: 'Agility Equipment', icon: '🏃' },
    { name: 'Waste Bags', icon: '🗑️' },
    { name: 'Shade/Trees', icon: '🌳' },
    { name: 'Off-Leash Area', icon: '🐕' },
    { name: 'Small Dog Area', icon: '🐕‍🦺' },
    { name: 'Large Dog Area', icon: '🐕' },
    { name: 'Lighting', icon: '💡' },
    { name: 'Restrooms', icon: '🚻' },
    { name: 'Walking Trails', icon: '🥾' },
    { name: 'Play Equipment', icon: '🛝' },
    { name: 'Dog Wash Station', icon: '🚿' },
    { name: 'Picnic Tables', icon: '🧺' }
  ];

  // Helper function to get current map center
  const getCurrentMapCenter = useCallback(() => {
    if (map && map.getCenter) {
      const center = map.getCenter();
      return {
        lat: center.lat(),
        lng: center.lng()
      };
    }
    // Fallback to localStorage if map not available
    const savedCenter = localStorage.getItem('lastMapCenter');
    if (savedCenter) {
      try {
        return JSON.parse(savedCenter);
      } catch (e) {
        console.error('Failed to parse saved map center:', e);
        return null;
      }
    }
    return null;
  }, [map]);

  // Helper function to get current map zoom level
  const getCurrentMapZoom = useCallback(() => {
    if (map && map.getZoom) {
      return map.getZoom();
    }
    // Fallback to localStorage if map not available
    const savedZoom = localStorage.getItem('lastMapZoom');
    if (savedZoom) {
      try {
        return parseInt(savedZoom, 10);
      } catch (e) {
        console.error('Failed to parse saved map zoom:', e);
        return 13; // Default zoom
      }
    }
    return 13; // Default zoom
  }, [map]);

  // Step 1: Fetch API Key
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        console.log('🔑 Fetching API configuration...');
        const response = await axios.get(`${API}/config`);
        console.log('✅ API Key loaded:', response.data.google_maps_api_key);
        setApiKey(response.data.google_maps_api_key);
      } catch (error) {
        console.error('❌ Failed to fetch configuration:', error);
        toast.error('Failed to load map configuration');
        setIsLoading(false);
      }
    };
    fetchConfig();
  }, []);

  // Check for new business pin context from localStorage
  useEffect(() => {
    const checkNewBusinessPin = async () => {
      const businessPinData = localStorage.getItem("newBusinessPin");
      if (!businessPinData) return;
      
      try {
        const pinContext = JSON.parse(businessPinData);
        
        // Check if data is not expired (30 seconds)
        if (Date.now() - pinContext.timestamp > 30000) {
          localStorage.removeItem("newBusinessPin");
          return;
        }
        
        // Wait for map and parks to be loaded
        if (map && dogParks.length > 0) {
          console.log("🎯 Handling new business pin:", pinContext);
          
          // Center map on new pin location with zoom
          map.setCenter({ lat: pinContext.lat, lng: pinContext.lng });
          map.setZoom(pinContext.zoom);
          
          // Find the newly created pin
          const newPin = dogParks.find(park => park.id === pinContext.id);
          if (newPin) {
            console.log("✅ Found new business pin:", newPin);
            // Just center on the pin - admin can click to edit
            toast.success("Business pin placed! Click the pin to add offer details.");
          } else {
            console.warn("⚠️ New business pin not found in parks array yet");
          }
          
          // Clear localStorage
          localStorage.removeItem("newBusinessPin");
        }
      } catch (error) {
        console.error("Error handling new business pin:", error);
        localStorage.removeItem("newBusinessPin");
      }
    };
    
    checkNewBusinessPin();
  }, [map, dogParks]);

  // Step 2: Load Google Maps Script
  useEffect(() => {
    if (!apiKey || initializationAttempted.current) return;

    initializationAttempted.current = true;

    // Check if already loaded
    if (window.google && window.google.maps) {
      console.log('✅ Google Maps already loaded');
      window.requestAnimationFrame(() => {
        console.log('🎬 Animation frame ready (already loaded), initializing map...');
        initMap();
      });
      return;
    }

    console.log('📦 Loading Google Maps script...');
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,geometry,marker`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      console.log('✅ Google Maps script loaded');
      // Use requestAnimationFrame to ensure DOM is painted
      window.requestAnimationFrame(() => {
        console.log('🎬 Animation frame ready, initializing map...');
        initMap();
      });
    };

    script.onerror = () => {
      console.error('❌ Failed to load Google Maps');
      toast.error('Failed to load Google Maps');
      setIsLoading(false);
    };

    document.head.appendChild(script);
  }, [apiKey]);

  // Step 3: Initialize Map
  const initMap = () => {
    console.log('🔍 initMap called, checking requirements...');
    console.log('  - mapContainerRef.current:', mapContainerRef.current);
    console.log('  - window.google:', !!window.google);
    
    if (!mapContainerRef.current) {
      console.error('❌ Map container not available, retrying in 100ms...');
      setTimeout(() => initMap(), 100);
      return;
    }
    
    if (!window.google) {
      console.error('❌ Google Maps not available');
      setIsLoading(false);
      return;
    }

    try {
      console.log('🗺️ Initializing map with container:', mapContainerRef.current);
      // Auckland, New Zealand as fallback default
      const aucklandCenter = { lat: -36.8485, lng: 174.7633 };
      const defaultCenter = aucklandCenter;

      const mapInstance = new window.google.maps.Map(mapContainerRef.current, {
        mapId: "DEMO_MAP_ID", // Required for AdvancedMarkerElement
        zoom: 11,
        center: defaultCenter,
        styles: [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }],
          },
          {
            featureType: 'transit',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }],
          },
        ],
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControlOptions: {
          position: window.google.maps.ControlPosition.RIGHT_BOTTOM,
        },
      });

      console.log('✅ Map created successfully');
      setMap(mapInstance);
      infoWindowRef.current = new window.google.maps.InfoWindow();

      // Smart location loading priority: localStorage → geolocation → Auckland
      try {
        const lastLocation = localStorage.getItem('lastMapLocation');
        if (lastLocation) {
          const { lat, lng, zoom } = JSON.parse(lastLocation);
          console.log('📍 Restoring last viewed location from localStorage:', lat, lng, zoom);
          mapInstance.setCenter({ lat, lng });
          mapInstance.setZoom(zoom);
          toast.success('Restored to your last viewed location');
        } else {
          // No saved location - try geolocation
          console.log('🌍 No saved location, attempting geolocation...');
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                const userLocation = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude
                };
                console.log('✅ Geolocation success:', userLocation);
                mapInstance.setCenter(userLocation);
                mapInstance.setZoom(13);
                toast.success('Map centered on your location');
              },
              (error) => {
                console.log('⚠️ Geolocation denied or unavailable:', error.message);
                console.log('📍 Using default location: Auckland, New Zealand');
                // Already centered on Auckland (defaultCenter)
              },
              { timeout: 5000, enableHighAccuracy: false }
            );
          } else {
            console.log('⚠️ Geolocation not supported by browser');
            console.log('📍 Using default location: Auckland, New Zealand');
          }
        }
      } catch (e) {
        console.log('⚠️ Error loading saved location:', e);
        console.log('📍 Using default location: Auckland, New Zealand');
      }

      // Save map position changes to localStorage (persist across sessions)
      mapInstance.addListener('idle', () => {
        const center = mapInstance.getCenter();
        const zoom = mapInstance.getZoom();
        localStorage.setItem('lastMapLocation', JSON.stringify({
          lat: center.lat(),
          lng: center.lng(),
          zoom: zoom
        }));
      });

      // Track map center for Add Location modal (debounced)
      let centerTimeout;
      mapInstance.addListener('center_changed', () => {
        clearTimeout(centerTimeout);
        centerTimeout = setTimeout(() => {
          const center = mapInstance.getCenter();
          if (center) {
            localStorage.setItem('lastMapCenter', JSON.stringify({
              lat: center.lat(),
              lng: center.lng()
            }));
          }
        }, 500); // Debounce by 500ms to avoid excessive writes
      });

      // Track map zoom for Add Location modal (debounced)
      let zoomTimeout;
      mapInstance.addListener('zoom_changed', () => {
        clearTimeout(zoomTimeout);
        zoomTimeout = setTimeout(() => {
          const zoom = mapInstance.getZoom();
          if (zoom) {
            localStorage.setItem('lastMapZoom', zoom.toString());
          }
        }, 500); // Debounce by 500ms to avoid excessive writes
      });

      // Remove loading overlay immediately so map can render
      console.log('🎉 Hiding loading overlay...');
      setIsLoading(false);

      // Wait for map idle before loading data
      window.google.maps.event.addListenerOnce(mapInstance, 'idle', () => {
        console.log('✅ Map fully loaded, loading data...');
        getCurrentLocation(mapInstance);
        loadDogParks();
        initializeAutocomplete(mapInstance);
      });

    } catch (error) {
      console.error('❌ Error initializing map:', error);
      toast.error(`Map error: ${error.message}`);
      setIsLoading(false);
    }
  };
  // Initialize the ref so it can be called from the script onload
  initMapFunctionRef.current = initMap;

  // Initialize autocomplete for search
  const initializeAutocomplete = (mapInstance) => {
    if (!searchInputRef.current || !window.google?.maps?.places) {
      console.log('⚠️ Autocomplete not available');
      return;
    }

    try {
      console.log('🔍 Initializing search autocomplete...');
      
      // TODO [Q2-Q3 2025]: Migrate to PlaceAutocompleteElement when Google issues 12-month warning
      // Current API: google.maps.places.Autocomplete (deprecated Mar 2025 for NEW customers only)
      // Migration blocked: PlaceAutocompleteElement breaks React controlled inputs (creates own input)
      // Strategy: Monitor deprecation timeline, migrate when React wrappers mature
      // See: /app/docs/project/FUTURE_TASKS.md - "Google Maps Autocomplete API Migration (Phase 2)"
      const autocomplete = new window.google.maps.places.Autocomplete(
        searchInputRef.current,
        {
          fields: ['formatted_address', 'geometry', 'name'],
          types: ['geocode', 'establishment']
        }
      );

      // Bind to map to bias results
      autocomplete.bindTo('bounds', mapInstance);

      // Handle place selection
      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();

        if (!place.geometry) {
          toast.error('No location details available');
          return;
        }

        // Move map to selected place
        if (place.geometry.viewport) {
          mapInstance.fitBounds(place.geometry.viewport);
        } else {
          mapInstance.setCenter(place.geometry.location);
          mapInstance.setZoom(15);
        }

        setSearchQuery(place.formatted_address || place.name);
        toast.success(`Found: ${place.name || place.formatted_address}`);
      });

      autocompleteRef.current = autocomplete;
      console.log('✅ Autocomplete initialized');
    } catch (error) {
      console.error('❌ Error initializing autocomplete:', error);
    }
  };

  // Get user location
  const getCurrentLocation = (mapInstance) => {
    if (!navigator.geolocation) {
      console.log('❌ Geolocation not supported');
      return;
    }

    console.log('📍 Getting user location...');
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const location = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        console.log('✅ Location found:', location);
        setUserLocation(location);
        mapInstance.setCenter(location);
        toast.dismiss('geolocation');

        // Add user marker using AdvancedMarkerElement
        const userMarkerContent = document.createElement('div');
        userMarkerContent.innerHTML = `
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="8" fill="#3B82F6" stroke="white" stroke-width="2"/>
            <circle cx="12" cy="12" r="3" fill="white"/>
          </svg>
        `;
        
        new window.google.maps.marker.AdvancedMarkerElement({
          position: location,
          map: mapInstance,
          title: 'Your Location',
          content: userMarkerContent,
        });
      },
      (error) => {
        console.error('❌ Geolocation error:', error);
        toast.dismiss('geolocation');
        
        let errorMessage = 'Could not get your location';
        
        switch(error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = 'Location access denied. Please enable location permissions in your browser settings.';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = 'Location information unavailable. Please check your device settings.';
            break;
          case error.TIMEOUT:
            errorMessage = 'Location request timed out. Please try again.';
            break;
        }
        
        toast.error(errorMessage, { duration: 5000 });
      },
      {
        enableHighAccuracy: true,
        timeout: 15000, // Increased timeout for better reliability
        maximumAge: 60000, // Cache for 1 minute
      }
    );
  };

  // Reload parks when amenities filter changes
  useEffect(() => {
    if (map && dogParks.length >= 0) {
      loadDogParks();
    }
  }, [selectedAmenities, map]); // Reload when amenities change

  // Load dog parks
  const loadDogParks = async () => {
    try {
      console.log('🐕 Loading dog parks...');
      
      // Build query parameters
      const params = new URLSearchParams();
      if (selectedAmenities.length > 0) {
        selectedAmenities.forEach(amenity => params.append('amenities', amenity));
        console.log('🔍 Filtering by amenities:', selectedAmenities);
      }
      
      const url = `${API}/parks${params.toString() ? '?' + params.toString() : ''}`;
      const response = await axios.get(url);
      console.log('✅ Loaded', response.data.length, 'parks');
      setDogParks(response.data);
      
      // Fetch active special offers
      try {
        const offersResponse = await axios.get(`${API}/special-offers`);
        setSpecialOffers(offersResponse.data.offers || []);
        console.log('✅ Loaded', offersResponse.data.offers?.length || 0, 'special offers');
      } catch (error) {
        console.error('Failed to load special offers:', error);
        setSpecialOffers([]);
      }
      
      // Check if we should focus on a specific park from URL (from Dashboard ratings)
      const urlParams = new URLSearchParams(window.location.search);
      const parkIdFromUrl = urlParams.get('parkId');
      if (parkIdFromUrl && map) {
        const targetPark = response.data.find(p => p.id === parkIdFromUrl);
        if (targetPark) {
          setTimeout(() => {
            map.setCenter({ lat: targetPark.latitude, lng: targetPark.longitude });
            map.setZoom(16);
            // Trigger the marker click to open InfoWindow
            const marker = markersRef.current.find(m => m.parkId === parkIdFromUrl);
            if (marker) {
              window.google.maps.event.trigger(marker, 'click');
            }
            toast.success(`Found: ${targetPark.name}`);
            // Clean URL
            window.history.replaceState({}, document.title, window.location.pathname);
          }, 1000);
        }
      }
      
      // Check if we should auto-open rating modal (from add location success)
      const openRating = sessionStorage.getItem('openRatingAfterAdd');
      const lastMapLocation = sessionStorage.getItem('lastMapLocation');
      if (openRating && lastMapLocation) {
        try {
          const location = JSON.parse(lastMapLocation);
          // Find the park at this location (newly added)
          const newPark = response.data.find(p => 
            Math.abs(p.latitude - location.lat) < 0.0001 && 
            Math.abs(p.longitude - location.lng) < 0.0001
          );
          
          if (newPark) {
            setTimeout(() => {
              setSelectedParkForRating(newPark);
              setShowRatingModal(true);
              toast.success(`Opening rating for ${newPark.name}`);
            }, 1500); // Delay to let map load and center
          }
          sessionStorage.removeItem('openRatingAfterAdd');
        } catch (e) {
          console.error('Error handling rating modal:', e);
        }
      }
      
      // Check if we should auto-open comments modal (from rating success)
      const openComments = sessionStorage.getItem('openCommentsForPark');
      if (openComments) {
        try {
          const parkInfo = JSON.parse(openComments);
          const park = response.data.find(p => p.id === parkInfo.id);
          if (park) {
            setTimeout(() => {
              setSelectedParkForComments(park);
              setShowCommentsModal(true);
              toast.success(`Opening comments for ${park.name}`);
            }, 1000); // Delay to let map load
          }
          sessionStorage.removeItem('openCommentsForPark');
        } catch (e) {
          console.error('Error parsing openCommentsForPark:', e);
        }
      }
    } catch (error) {
      console.error('❌ Error loading parks:', error);
      toast.error('Failed to load dog parks');

      // Try creating sample data
      try {
        console.log('🔄 Creating sample data...');
        await axios.post(`${API}/parks/sample-data`);
        const retryResponse = await axios.get(`${API}/parks`);
        setDogParks(retryResponse.data);
        toast.success('Sample parks loaded!');
      } catch (sampleError) {
        console.error('❌ Error creating sample data:', sampleError);
      }
    }
  };

  // Add markers when parks or map changes OR when showRatings toggle changes
  useEffect(() => {
    if (!map || !dogParks.length) return;

    console.log('📍 Adding', dogParks.length, 'markers');
    
    // Update ref to current showRatings value
    showRatingsRef.current = showRatings;

    // Clear old rating overlays
    ratingOverlaysRef.current.forEach(overlay => overlay.close());
    ratingOverlaysRef.current = [];

    // Clear old markers
    markersRef.current.forEach(marker => marker.setMap(null));
    markersRef.current = [];

    // Add new markers using AdvancedMarkerElement
    dogParks.forEach((park) => {
      // Get color and emoji for this pin type (admin specialist pins)
      const pinColor = getPinColor(park.category || 'standard');
      const pinEmoji = getPinEmoji(park.category || 'standard');
      
      // Check if this park has an active special offer
      const hasOffer = specialOffers.find(offer => offer.park_id === park.id);
      const isBusinessPin = park.category && park.category !== 'standard';
      
      // Create HTML content for marker with pulsing animation
      const markerContent = document.createElement('div');
      markerContent.className = 'park-marker';
      markerContent.style.cssText = `
        position: relative;
        width: 56px;
        height: 56px;
        cursor: pointer;
      `;
      
      markerContent.innerHTML = `
        <style>
          @keyframes pulse {
            0%, 100% { 
              transform: scale(1);
              opacity: 1;
            }
            50% { 
              transform: scale(1.12);
              opacity: 0.85;
            }
          }
          @keyframes glow {
            0%, 100% { 
              opacity: 0.4;
              transform: scale(1);
            }
            50% { 
              opacity: 0;
              transform: scale(1.14);
            }
          }
          @keyframes offerPulse {
            0%, 100% {
              box-shadow: 0 0 8px 2px rgba(255, 215, 0, 0.6);
              transform: scale(1);
            }
            50% {
              box-shadow: 0 0 16px 4px rgba(255, 215, 0, 0.8);
              transform: scale(1.08);
            }
          }
          .marker-circle {
            animation: pulse 2s ease-in-out infinite;
          }
          .marker-glow {
            animation: glow 2s ease-in-out infinite;
          }
          .offer-bubble {
            animation: offerPulse 1.5s ease-in-out infinite;
          }
        </style>
        <svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" style="position: absolute; top: 0; left: 0;">
          <!-- Outer glow ring for strobe effect -->
          <circle class="marker-glow" cx="28" cy="28" r="28" fill="none" stroke="${pinColor}" stroke-width="2" opacity="0.4" />
          
          <!-- Animated circle with energetic pulse - Dynamic color based on pin type -->
          <circle class="marker-circle" cx="28" cy="28" r="26" fill="white" stroke="${pinColor}" stroke-width="3" />
        </svg>
        <div style="position: absolute; top: 10px; left: 10px; width: 36px; height: 36px; display: flex; align-items: center; justify-content: center; font-size: 24px; pointer-events: none;">${pinEmoji}</div>
        ${hasOffer && isBusinessPin ? `
          <div class="offer-bubble" style="
            position: absolute;
            top: -6px;
            right: -6px;
            width: 32px;
            height: 32px;
            background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 8px;
            font-weight: bold;
            color: #10B981;
            text-shadow: 0 0 2px rgba(255,255,255,0.8);
            cursor: pointer;
            z-index: 10;
            border: 2px solid white;
          ">
            Offer!
          </div>
        ` : ''}
      `;
      
      const marker = new window.google.maps.marker.AdvancedMarkerElement({
        position: { lat: park.latitude, lng: park.longitude },
        map: map,
        title: park.name,
        content: markerContent,
      });
      
      // Store park ID and offer on marker for later reference
      marker.parkId = park.id;
      marker.hasOffer = hasOffer;
      marker.parkData = park;
      
      // Add click handler for offer bubble (if exists)
      if (hasOffer && isBusinessPin) {
        const bubbleElement = markerContent.querySelector('.offer-bubble');
        if (bubbleElement) {
          bubbleElement.addEventListener('click', (e) => {
            e.stopPropagation(); // Prevent marker click
            
            // Both admin and user click offer → Show SpecialOfferModal
            // Admin gets edit button inside the modal
            setSelectedOffer(hasOffer);
            setSelectedParkForOffer(park);
            setShowOfferModal(true);
            
            // Track analytics for non-admin users
            if (!user || (user.role !== 'admin' && user.role !== 'master')) {
              analyticsTracker.trackClick(park.id);
            }
          });
        }
      }

      // Create click handler for main marker
      const handleMarkerClick = async () => {
        // === BUSINESS PIN HANDLING (Preview-First Flow) ===
        if (isBusinessPin) {
          // Admin clicks business pin → Show preview (formatted offer or blank placeholder)
          if (user && (user.role === 'admin' || user.role === 'master')) {
            const existingOffer = specialOffers.find(o => o.park_id === park.id);
            if (existingOffer) {
              // Show existing offer preview
              setSelectedOffer(existingOffer);
              setSelectedParkForOffer(park);
              setShowOfferModal(true);
            } else {
              // Show blank placeholder preview
              const placeholderOffer = {
                id: 'placeholder',
                park_id: park.id,
                offer_description: '<div class="text-center py-8"><p class="text-gray-500 text-lg mb-2">📝 No offer created yet</p><p class="text-gray-400 text-sm">Click "Go to Edit Screen" below to create your special offer</p></div>',
                expiration_date: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(), // 30 days from now
                terms: '',
                business_name: park.name
              };
              setSelectedOffer(placeholderOffer);
              setSelectedParkForOffer(park);
              setShowOfferModal(true);
            }
            return;
          }
          
          // Regular user clicks business pin WITH offer → Show offer modal
          if (hasOffer) {
            setSelectedOffer(hasOffer);
            setSelectedParkForOffer(park);
            setShowOfferModal(true);
            // Track analytics: offer view
            analyticsTracker.trackView(park.id);
            return;
          }
          
          // Regular user clicks business pin WITHOUT offer → "Coming soon"
          toast.info('Special offer coming soon! Check back later.', {
            duration: 3000,
            icon: '🎉'
          });
          return;
        }
        
        // === STANDARD DOG PARK HANDLING (Unchanged) ===
        // Otherwise, show regular park info panel
        try {
          // Get park creator info and badges
          let creatorInfo = null;
          if (park.created_by) {
            try {
              const creatorResponse = await axios.get(`${BACKEND_URL}/api/users/${park.created_by}/profile`);
              creatorInfo = creatorResponse.data;
            } catch (e) {
              console.log('Could not fetch creator info:', e);
            }
          }

          // Check if user can edit this park (7-day window)
          const canEditPark = () => {
            if (park.edit_window_expires) {
              const expiryDate = new Date(park.edit_window_expires);
              return new Date() < expiryDate;
            }
            // Legacy fallback
            if (park.created_at) {
              const createdAt = new Date(park.created_at);
              const sevenDaysAgo = new Date();
              sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
              return createdAt > sevenDaysAgo;
            }
            return false;
          };

          // Create clean InfoWindow with interactive park name button
          const content = `
            <div id="park-info-container" style="font-family: 'Space Grotesk', sans-serif; display: flex; flex-direction: column; align-items: center; position: relative; max-width: 320px;">
              
              <!-- Interactive Park Name Button (Replaces static banner + bottom button) -->
              <div style="display: flex; flex-direction: column; align-items: center; margin: 12px 0 16px 0; position: relative;">
                <!-- "Click Here" Hint - IMMEDIATELY ABOVE button with pointing down arrow -->
                <div id="click-hint-${park.id}" style="
                  margin-bottom: 8px;
                  background: linear-gradient(135deg, #fbbf24, #f59e0b);
                  color: #78350f;
                  padding: 6px 14px;
                  border-radius: 16px;
                  font-size: 12px;
                  font-weight: bold;
                  animation: fadeInHint 0.5s ease-out 3.6s forwards, strobeHint 1.5s ease-in-out 4.1s infinite;
                  opacity: 0;
                  box-shadow: 0 4px 12px rgba(251, 191, 36, 0.5);
                  pointer-events: none;
                  white-space: nowrap;
                  display: none;
                ">
                  Click Here 👇
                </div>
                
                <!-- Park Name Button (Always Visible, Opens Menu) - 3mm border each side -->
                <button id="pin-interaction-btn" onclick="togglePinInteractionMenu('${park.id}', '${park.name}', ${park.latitude}, ${park.longitude})" 
                  style="
                    width: calc(100% - 6mm);
                    padding: 12px 16px;
                    background: linear-gradient(135deg, #10b981, #059669);
                    color: white;
                    border: 2px solid #059669;
                    border-radius: 16px;
                    font-size: 14px;
                    font-weight: 700;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    transition: all 0.3s ease;
                    animation: gentlePulse 2s ease-in-out infinite;
                    box-shadow: 
                      0 3px 12px rgba(16, 185, 129, 0.4),
                      0 0 15px rgba(16, 185, 129, 0.3);
                  "
                  onmouseover="this.style.transform='scale(1.05)'; this.style.animationPlayState='paused';"
                  onmouseout="this.style.transform='scale(1)'; this.style.animationPlayState='running';">
                  <span style="font-size: 16px;">👆</span>
                  <span>${park.name}</span>
                </button>
                
                <script>
                  // Show click hint for first-time users
                  (function() {
                    const clickCount = parseInt(sessionStorage.getItem('pin-action-clicks') || '0');
                    const hint = document.getElementById('click-hint-${park.id}');
                    
                    if (clickCount < 3 && hint) {
                      hint.style.display = 'block';
                      
                      // Hide hint after user clicks button or after 15 seconds
                      const btn = document.getElementById('pin-interaction-btn');
                      const hideHint = () => {
                        if (hint && hint.parentNode) {
                          hint.style.opacity = '0';
                          setTimeout(() => {
                            if (hint && hint.parentNode) {
                              hint.style.display = 'none';
                            }
                          }, 500);
                        }
                        sessionStorage.setItem('pin-action-clicks', (clickCount + 1).toString());
                      };
                      
                      btn.addEventListener('click', hideHint, { once: true });
                      setTimeout(hideHint, 15000); // Auto-hide after 15s
                    }
                  })();
                </script>
              </div>

              <!-- Clean Modern Information Panel (Compact) -->
              <div id="park-info-panel" style="
                position: relative;
                padding: 16px 18px;
                background: white;
                border-radius: 12px;
                min-width: 280px;
                max-width: 310px;
                box-shadow: 0 8px 32px rgba(0,0,0,0.15);
                border: 2px solid #e5e7eb;
                overflow: visible;
              ">

                <!-- Park Info (Compact) -->
                <p style="color: #4A5568; font-size: 12px; line-height: 1.4; margin-bottom: 12px; text-align: center; font-style: italic;">${park.description || 'A wonderful place for dog walking!'}</p>
                
                <!-- Rating (conditionally shown, compact) - Only for dog parks, not business pins -->
                ${!isBusinessPin && (showRatingsRef.current || (park.rating_count && park.rating_count > 0)) ? `
                <div style="display: flex; align-items: center; justify-content: center; gap: 4px; margin-bottom: 12px; padding: 6px; background: rgba(251, 191, 36, 0.1); border-radius: 6px;">
                  <span style="color: #fbbf24; font-size: 15px;">★</span>
                  <span style="font-weight: 700; color: #2D4A22; font-size: 14px;">${park.rating?.toFixed(1) || '0.0'}</span>
                  <span style="color: #6b7280; font-size: 11px;">(${park.rating_count || 0} ${park.rating_count === 1 ? 'review' : 'reviews'})</span>
                </div>
                ` : ''}
                
                <!-- Address Section (Compact) -->
                <div style="margin-bottom: 12px; padding: 8px 10px; background: rgba(16, 185, 129, 0.08); border-radius: 6px; border: 1.5px solid rgba(16, 185, 129, 0.2);">
                  <p style="font-weight: 700; color: #2D4A22; font-size: 12px; margin-bottom: 4px; display: flex; align-items: center; gap: 4px;"><span>📍</span>Address</p>
                  <p style="font-size: 11px; color: #374151; margin: 0; line-height: 1.3;">${park.address || 'Address not available'}</p>
                </div>
                
                ${park.amenities && park.amenities.length > 0 ? `
                <!-- Amenities (Compact) -->
                <div style="margin-bottom: 12px;">
                  <p style="font-weight: 700; color: #2D4A22; font-size: 12px; margin-bottom: 6px; display: flex; align-items: center; gap: 4px;"><span>🏞️</span>Amenities</p>
                  <div style="display: flex; flex-wrap: wrap; gap: 4px; justify-content: center;">
                    ${park.amenities.map(amenity => {
                      const iconMap = {
                        'Parking': '🅿️', 'Water Fountain': '💧', 'Fenced Area': '🚧', 'Benches': '🪑',
                        'Agility Equipment': '🏃', 'Waste Bags': '🗑️', 'Shade/Trees': '🌳', 'Off-Leash Area': '🐕',
                        'Small Dog Area': '🐕‍🦺', 'Large Dog Area': '🦮', 'Lighting': '💡', 'Restrooms': '🚻',
                        'Walking Trails': '🥾', 'Play Equipment': '🛝', 'Dog Wash Station': '🚿', 'Picnic Tables': '🍽️',
                        // Legacy mappings
                        'Off-leash area': '🐕', 'Water fountains': '💧', 'Agility equipment': '🏃', 'Shade': '🌳',
                        'Waste bags': '🗑️', 'Fenced area': '🚧', 'Small dog area': '🐕‍🦺', 'Large dog area': '🦮', 'Parking available': '🅿️'
                      };
                      const icon = iconMap[amenity] || '•';
                      return `<span style="display: flex; align-items: center; gap: 2px; background: linear-gradient(135deg, #ecfdf5, #d1fae5); color: #065f46; padding: 3px 6px; border-radius: 10px; font-size: 10px; font-weight: 600; border: 1px solid rgba(16, 185, 129, 0.3);"><span>${icon}</span><span>${amenity}</span></span>`;
                    }).join('')}
                  </div>
                </div>
                ` : ''}
                
                <!-- Close Button - Positioned INSIDE panel for full visibility -->
                <button onclick="closeInfoWindow()" 
                  style="position: absolute; top: 8px; right: 8px; width: 30px; height: 30px; background: linear-gradient(135deg, #8B4513, #A0522D); color: white; border: none; border-radius: 50%; font-size: 18px; font-weight: bold; cursor: pointer; box-shadow: 0 3px 10px rgba(139, 69, 19, 0.5); z-index: 100; display: flex; align-items: center; justify-content: center; transition: all 0.2s ease;"
                  onmouseover="this.style.background='linear-gradient(135deg, #A0522D, #8B4513)'; this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 15px rgba(139, 69, 19, 0.6)';" 
                  onmouseout="this.style.background='linear-gradient(135deg, #8B4513, #A0522D)'; this.style.transform='scale(1)'; this.style.boxShadow='0 3px 10px rgba(139, 69, 19, 0.5)';">
                  ×
                </button>
              </div>
              
            </div>
          `;

          // Enhanced menu action functions for wooden sign with floating menu
          window.closeInfoWindow = () => {
            // Hide pin interaction menu if open
            const pinMenu = document.getElementById('floating-pin-menu');
            if (pinMenu) {
              document.body.removeChild(pinMenu);
            }
            
            infoWindowRef.current.close();
          };

          // Pin Interaction Menu Toggle - OVERLAY APPROACH
          window.togglePinInteractionMenu = (parkId, parkName, lat, lng) => {
            const existingOverlay = document.getElementById('pin-menu-overlay');
            
            // If overlay exists, remove it and restart button animation
            if (existingOverlay) {
              document.body.removeChild(existingOverlay);
              // Restart park name button animation
              const parkNameBtn = document.getElementById('pin-interaction-btn');
              if (parkNameBtn) {
                parkNameBtn.style.animationPlayState = 'running';
              }
              return;
            }

            // Pause park name button animation when opening menu
            const parkNameBtn = document.getElementById('pin-interaction-btn');
            if (parkNameBtn) {
              parkNameBtn.style.animationPlayState = 'paused';
            }

            // Create full-screen overlay (opaque to hide strobing beneath)
            const overlayContainer = document.createElement('div');
            overlayContainer.id = 'pin-menu-overlay';
            overlayContainer.style.cssText = `
              position: fixed;
              top: 0;
              left: 0;
              width: 100vw;
              height: 100vh;
              background: rgba(0, 0, 0, 0.85);
              backdrop-filter: blur(8px);
              z-index: 10000;
              display: flex;
              align-items: center;
              justify-content: center;
              animation: overlayFadeIn 0.3s ease-out;
            `;

            // Create centered menu positioned over info panel
            const menuContainer = document.createElement('div');
            menuContainer.id = 'floating-pin-menu';
            menuContainer.style.cssText = `
              position: relative;
              display: flex;
              flex-direction: column;
              gap: 12px;
              padding: 24px;
              background: rgba(255, 255, 255, 0.98);
              border-radius: 20px;
              box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
              border: 3px solid rgba(16, 185, 129, 0.4);
              backdrop-filter: blur(15px);
              animation: menuPopIn 0.4s ease-out;
              max-width: 320px;
              min-width: 280px;
            `;

            // Menu items with enhanced styling
            const menuItems = [
              { icon: '⭐', text: 'Rate Location', color: '#d97706', action: `ratePark('${parkId}', '${parkName}')` },
              { icon: '💬', text: 'Comments', color: '#0ea5e9', action: `openComments('${parkId}')` },
              { icon: '🔗', text: 'Share', color: '#06b6d4', action: `toggleShareSubmenu('${parkId}', '${parkName}', ${lat}, ${lng})` },
              { icon: '🧭', text: 'Directions', color: '#14b8a6', action: `getDirections(${lat}, ${lng}, '${parkName}')` },
              { icon: '🚨', text: 'Report', color: '#f97316', action: `reportContent('${parkId}')` },
              { icon: '❌', text: 'Not Dog Park', color: '#fb923c', action: `reportNotDogPark('${parkId}')` }
            ];

            // Add admin-only buttons if user has admin/master role
            // Pass role from React context into the InfoWindow JavaScript
            const userRole = user?.role || '';
            if (userRole === 'admin' || userRole === 'master') {
              menuItems.push(
                { icon: '✏️', text: 'Edit Park Name', color: '#f59e0b', action: `adminEditParkName('${parkId}', '${parkName}')`, isAdmin: true },
                { icon: '📍', text: 'Move Pin', color: '#8b5cf6', action: `adminMovePark('${parkId}', '${parkName}', ${lat}, ${lng})`, isAdmin: true }
              );
            }

            // Add delete button if user owns the park and within edit window
            const userId = user?.id || '';
            const parkCreatedBy = park.created_by || '';
            const userOwnsThisPark = userId && parkCreatedBy && userId === parkCreatedBy;
            const canDelete = userOwnsThisPark && canEditPark();
            
            if (canDelete) {
              menuItems.push(
                { icon: '🗑️', text: 'Delete Location', color: '#dc2626', action: `deleteParkFromMap('${parkId}', '${parkName}')` }
              );
            }

            menuItems.forEach((item, index) => {
              const button = document.createElement('button');
              button.style.cssText = `
                padding: 10px 16px;
                background: linear-gradient(135deg, ${item.color}, ${item.color}dd);
                color: white;
                border: none;
                border-radius: 12px;
                font-size: 13px;
                font-weight: 600;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 8px;
                transition: all 0.3s ease;
                box-shadow: 0 4px 15px ${item.color}44;
                animation: menuItemIn 0.4s ease-out ${index * 0.05}s both;
                min-width: 160px;
              `;
              
              button.innerHTML = `<span>${item.icon}</span><span>${item.text}</span>`;
              
              button.onmouseover = () => {
                button.style.transform = 'translateX(-4px) scale(1.05)';
                button.style.boxShadow = `0 6px 20px ${item.color}66`;
              };
              
              button.onmouseout = () => {
                button.style.transform = 'translateX(0) scale(1)';
                button.style.boxShadow = `0 4px 15px ${item.color}44`;
              };
              
              button.onclick = () => {
                eval(item.action);
                // Safely remove overlay container
                try {
                  if (overlayContainer && overlayContainer.parentNode) {
                    overlayContainer.parentNode.removeChild(overlayContainer);
                  }
                } catch (e) {
                  console.log('Overlay already removed');
                }
              };
              
              menuContainer.appendChild(button);
            });

            // Add title to menu
            const menuTitle = document.createElement('h3');
            menuTitle.style.cssText = `
              margin: 0 0 16px 0;
              color: #2D4A22;
              font-size: 18px;
              font-weight: 700;
              text-align: center;
              border-bottom: 2px solid #10b981;
              padding-bottom: 12px;
            `;
            menuTitle.innerHTML = `Pin Actions`;
            menuContainer.insertBefore(menuTitle, menuContainer.firstChild);

            // Close button
            const closeBtn = document.createElement('button');
            closeBtn.style.cssText = `
              position: absolute;
              top: -10px;
              right: -10px;
              width: 28px;
              height: 28px;
              background: linear-gradient(135deg, #8B4513, #A0522D);
              color: white;
              border: none;
              border-radius: 50%;
              font-size: 16px;
              font-weight: bold;
              cursor: pointer;
              box-shadow: 0 4px 12px rgba(139, 69, 19, 0.5);
              z-index: 10;
            `;
            closeBtn.innerHTML = '×';
            closeBtn.onclick = () => {
              // Restart park name button animation
              const parkNameBtn = document.getElementById('pin-interaction-btn');
              if (parkNameBtn) {
                parkNameBtn.style.animationPlayState = 'running';
              }
              try {
                if (overlayContainer && overlayContainer.parentNode) {
                  overlayContainer.parentNode.removeChild(overlayContainer);
                }
              } catch (e) {
                console.log('Overlay already removed');
              }
            };
            
            menuContainer.appendChild(closeBtn);

            // Close overlay when clicking outside menu
            overlayContainer.onclick = (e) => {
              if (e.target === overlayContainer) {
                // Restart park name button animation
                const parkNameBtn = document.getElementById('pin-interaction-btn');
                if (parkNameBtn) {
                  parkNameBtn.style.animationPlayState = 'running';
                }
                try {
                  if (overlayContainer && overlayContainer.parentNode) {
                    overlayContainer.parentNode.removeChild(overlayContainer);
                  }
                } catch (err) {
                  console.log('Overlay already removed');
                }
              }
            };

            // Prevent menu clicks from closing overlay
            menuContainer.onclick = (e) => e.stopPropagation();

            // Add animations to stylesheet
            if (!document.getElementById('overlay-menu-styles')) {
              const menuStyles = document.createElement('style');
              menuStyles.id = 'overlay-menu-styles';
              menuStyles.textContent = `
                @keyframes overlayFadeIn {
                  from {
                    opacity: 0;
                  }
                  to {
                    opacity: 1;
                  }
                }
                
                @keyframes menuPopIn {
                  from {
                    opacity: 0;
                    transform: scale(0.8) translateY(-20px);
                  }
                  to {
                    opacity: 1;
                    transform: scale(1) translateY(0);
                  }
                }
                
                @keyframes menuItemIn {
                  from {
                    opacity: 0;
                    transform: translateY(10px);
                  }
                  to {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }
              `;
              document.head.appendChild(menuStyles);
            }

            overlayContainer.appendChild(menuContainer);
            document.body.appendChild(overlayContainer);
          };

          // Authentication check helper
          window.checkAuthentication = () => {
            return isAuthenticated;
          };

          window.showAuthError = () => {
            if (confirm('Sorry, you need to be logged in to use this feature. Registration is quick and simple! Would you like to go to the registration page?')) {
              window.location.href = '/dashboard'; // Dashboard has registration modal
            }
          };

          window.ratePark = (parkId, parkName) => {
            console.log('🌟 Rate Park clicked:', parkId, parkName);
            
            if (!window.checkAuthentication()) {
              window.showAuthError();
              return;
            }
            
            // Find the park data
            const parkData = dogParks.find(p => p.id === parkId);
            
            // Close info window and open rating modal
            infoWindowRef.current.close();
            
            // Set the selected park and open modal
            setSelectedParkForRating(parkData);
            setShowRatingModal(true);
            
            toast.success(`Opening rating for ${parkName}`);
          };

          // Open Comments Modal directly (no submenu)
          window.openComments = (parkId) => {
            console.log('💬 Comments clicked:', parkId);
            
            // Find park data
            const parkData = dogParks.find(p => p.id === parkId);
            
            // Close info window and pin menu overlay safely
            try {
              const pinMenuOverlay = document.getElementById('pin-menu-overlay');
              if (pinMenuOverlay && pinMenuOverlay.parentNode) {
                pinMenuOverlay.parentNode.removeChild(pinMenuOverlay);
              }
            } catch (e) {
              console.log('Pin menu already closed');
            }
            
            infoWindowRef.current.close();
            
            // Set selected park and open comments modal
            setSelectedParkForComments(parkData);
            setShowCommentsModal(true);
            
            toast.success('Opening comments...');
          };

          // Share submenu toggle with social media icons (responsive positioning)
          window.toggleShareSubmenu = (parkId, parkName, lat, lng) => {
            const existingSubmenu = document.getElementById('floating-share-submenu');
            
            if (existingSubmenu) {
              document.body.removeChild(existingSubmenu);
              return;
            }

            const shareSubmenuContainer = document.createElement('div');
            shareSubmenuContainer.id = 'floating-share-submenu';
            
            // Responsive positioning: center on mobile, right-aligned on desktop
            const isMobile = window.innerWidth < 640;
            shareSubmenuContainer.style.cssText = `
              position: fixed;
              ${isMobile ? `
                bottom: 100px;
                left: 50%;
                transform: translateX(-50%);
              ` : `
                top: 50%;
                right: 220px;
                transform: translateY(-50%);
              `}
              z-index: 10001;
              display: flex;
              ${isMobile ? 'flex-direction: row;' : ''}
              gap: 12px;
              padding: 16px;
              background: rgba(255, 255, 255, 0.98);
              border-radius: 20px;
              box-shadow: 0 12px 48px rgba(0, 0, 0, 0.25);
              border: 3px solid rgba(16, 185, 129, 0.4);
              backdrop-filter: blur(12px);
              animation: submenuSlideIn 0.3s ease-out;
            `;


            const shareUrl = `https://www.google.com/maps?q=${lat},${lng}`;
            const shareText = `Check out ${parkName} - a great dog park!`;

            // Create social media icons
            const socialButtons = [
              { icon: '📘', name: 'Facebook', color: '#1877F2', action: () => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, '_blank', 'width=600,height=400') },
              { icon: '𝕏', name: 'X (Twitter)', color: '#000000', action: () => window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`, '_blank', 'width=600,height=400') },
              { icon: '💬', name: 'WhatsApp', color: '#25D366', action: () => window.open(`https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`, '_blank') },
              { icon: '📋', name: 'Copy', color: '#6B7280', action: () => {
                navigator.clipboard.writeText(shareUrl).then(() => {
                  toast.success(`Share link for ${parkName} copied to clipboard!`);
                  document.body.removeChild(shareSubmenuContainer);
                }).catch(() => {
                  toast.info(`Share: ${shareUrl}`);
                });
              }}
            ];

            socialButtons.forEach((social, index) => {
              const btn = document.createElement('button');
              btn.style.cssText = `
                width: ${isMobile ? '48px' : '44px'};
                height: ${isMobile ? '48px' : '44px'};
                border-radius: 50%;
                background: ${social.color};
                color: white;
                border: none;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: ${isMobile ? '22px' : '20px'};
                transition: all 0.3s ease;
                box-shadow: 0 4px 12px ${social.color}44;
                animation: socialIconFanIn ${0.4 + index * 0.1}s ease-out;
              `;
              btn.innerHTML = social.icon;
              btn.title = social.name;
              
              btn.onmouseover = () => btn.style.transform = 'scale(1.15)';
              btn.onmouseout = () => btn.style.transform = 'scale(1)';
              btn.onclick = () => {
                social.action();
                if (social.name !== 'Copy') {
                  toast.success(`Opening ${social.name} share...`);
                }
                // Auto-close the share submenu after clicking any option
                if (document.body.contains(shareSubmenuContainer)) {
                  document.body.removeChild(shareSubmenuContainer);
                }
              };
              
              shareSubmenuContainer.appendChild(btn);
            });

            // Add close button to share submenu
            const closeBtn = document.createElement('button');
            closeBtn.style.cssText = `
              width: ${isMobile ? '48px' : '44px'};
              height: ${isMobile ? '48px' : '44px'};
              border-radius: 50%;
              background: linear-gradient(135deg, #f97316, #ea580c);
              color: white;
              border: none;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: ${isMobile ? '24px' : '22px'};
              font-weight: bold;
              transition: all 0.3s ease;
              box-shadow: 0 4px 12px rgba(249, 115, 22, 0.4);
              animation: socialIconFanIn ${0.4 + socialButtons.length * 0.1}s ease-out;
            `;
            closeBtn.innerHTML = '×';
            closeBtn.title = 'Close';
            closeBtn.onmouseover = () => closeBtn.style.transform = 'scale(1.15)';
            closeBtn.onmouseout = () => closeBtn.style.transform = 'scale(1)';
            closeBtn.onclick = () => {
              if (document.body.contains(shareSubmenuContainer)) {
                document.body.removeChild(shareSubmenuContainer);
              }
            };
            shareSubmenuContainer.appendChild(closeBtn);

            document.body.appendChild(shareSubmenuContainer);
          };

          // Old addComment and readComments functions removed - now using openComments directly

          // Social media share functions
          window.shareToFacebook = (url, text) => {
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank', 'width=600,height=400');
            toast.success('Opening Facebook share...');
          };

          window.shareToTwitter = (url, text) => {
            window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`, '_blank', 'width=600,height=400');
            toast.success('Opening Twitter share...');
          };

          window.shareToWhatsApp = (url, text) => {
            window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
            toast.success('Opening WhatsApp share...');
          };

          window.copyShareLink = (url, parkName) => {
            navigator.clipboard.writeText(url).then(() => {
              toast.success(`Share link for ${parkName} copied to clipboard!`);
              infoWindowRef.current.close();
            }).catch(() => {
              toast.info(`Share: ${url}`);
            });
          };

          window.getDirections = (lat, lng, parkName) => {
            console.log('🧭 Get Directions clicked:', lat, lng);
            const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
            window.open(directionsUrl, '_blank');
            toast.success(`Opening directions to ${parkName}`);
          };

          window.reportContent = (parkId) => {
            console.log('🚨 Report Content clicked:', parkId);
            
            if (!window.checkAuthentication()) {
              window.showAuthError();
              return;
            }
            
            const reportReason = prompt('Please briefly describe the issue (inappropriate name, incorrect information, etc.):');
            if (reportReason && reportReason.trim()) {
              // Call the general report endpoint with proper format
              axios.post(`${BACKEND_URL}/api/parks/${parkId}/report`, {
                report_type: "other",
                description: reportReason.trim()
              }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
              }).then(response => {
                toast.success(response.data.message);
              }).catch(error => {
                const message = error.response?.data?.detail || 'Failed to submit report';
                toast.error(message);
              });
            }
          };

          window.reportNotDogPark = (parkId) => {
            console.log('❌ Report Not Dog Park clicked:', parkId);
            
            if (!window.checkAuthentication()) {
              window.showAuthError();
              return;
            }
            
            if (confirm('Are you sure this location is not actually a dog park? This will help improve our community accuracy.')) {
              // Call the backend endpoint
              axios.post(`${BACKEND_URL}/api/parks/${parkId}/report-not-dog-park`, {}, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
              }).then(response => {
                toast.success(response.data.message);
                infoWindowRef.current.close();
              }).catch(error => {
                const message = error.response?.data?.detail || 'Failed to submit report';
                toast.error(message);
              });
            }
          };

          window.deleteParkFromMap = async (parkId, parkName) => {
            console.log('🗑️ Delete Location clicked:', parkId);
            
            if (!window.checkAuthentication()) {
              window.showAuthError();
              return;
            }
            
            try {
              // Get auth token
              const token = localStorage.getItem('token');
              if (!token) {
                toast.error('Please log in to delete parks');
                return;
              }
              
              const headers = { Authorization: `Bearer ${token}` };
              
              // First, get deletion info
              console.log('🔍 Fetching deletion info for park:', parkId);
              const infoResponse = await axios.get(`${BACKEND_URL}/api/parks/${parkId}/deletion-info`, { headers });
              const { counts, is_popular } = infoResponse.data;
              
              // Build confirmation message with counts
              let confirmMessage = `Are you sure you want to delete "${parkName}"?\n\nThis will permanently delete:\n`;
              confirmMessage += `• The park location\n`;
              if (counts.comments > 0) confirmMessage += `• ${counts.comments} comment(s)\n`;
              if (counts.ratings > 0) confirmMessage += `• ${counts.ratings} rating(s)\n`;
              if (counts.reports > 0) confirmMessage += `• ${counts.reports} report(s)\n`;
              confirmMessage += `\n⚠️ This action cannot be undone.`;
              
              if (is_popular) {
                confirmMessage += `\n\n📊 Note: This is a popular park (>10 ratings). Your request will be sent to admin for review.`;
              }
              
              if (!confirm(confirmMessage)) {
                return;
              }

              console.log('🗑️ Deleting park:', parkId);
              const response = await axios.delete(`${BACKEND_URL}/api/parks/${parkId}`, { headers });
              
              console.log('✅ Delete response:', response.data);
              
              if (response.data.requires_approval) {
                toast.success('Deletion request submitted for admin review (popular park)');
              } else {
                const deletedCounts = response.data.deleted_counts || {};
                let successMsg = 'Park deleted successfully';
                if (deletedCounts.comments > 0 || deletedCounts.ratings > 0) {
                  successMsg += ` (${deletedCounts.comments || 0} comments, ${deletedCounts.ratings || 0} ratings removed)`;
                }
                toast.success(successMsg);
              }
              
              // Close InfoWindow safely
              try {
                if (infoWindowRef.current && infoWindowRef.current.close) {
                  infoWindowRef.current.close();
                }
              } catch (e) {
                console.warn('Could not close InfoWindow:', e);
              }
              
              // Refresh parks to update the map
              console.log('🔄 Refreshing parks list...');
              await loadDogParks();
              console.log('✅ Parks list refreshed');
              
            } catch (error) {
              console.error('❌ Error deleting park:', error);
              if (error.response?.status === 403) {
                toast.error(error.response.data.detail || 'Cannot delete this park');
              } else if (error.response?.status === 404) {
                toast.error('Park not found');
              } else {
                toast.error(error.response?.data?.detail || 'Failed to delete park. Please try again.');
              }
            }
          };

          // ADMIN FUNCTIONS
          window.adminEditParkName = (parkId, currentName) => {
            console.log('✏️ Admin: Edit Park Name clicked:', parkId);
            
            const newName = prompt(`Enter new park name:\n(Current: ${currentName})`, currentName);
            if (!newName || newName === currentName) {
              return;
            }
            
            // Call the backend admin endpoint
            axios.patch(`${BACKEND_URL}/api/admin/parks/${parkId}/name`, 
              { new_name: newName },
              { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
            ).then(response => {
              toast.success('Park name updated successfully!');
              // Refresh parks to show updated name
              fetchDogParks();
              infoWindowRef.current.close();
            }).catch(error => {
              const message = error.response?.data?.detail || 'Failed to update park name';
              toast.error(message);
            });
          };

          window.adminMovePark = (parkId, parkName, currentLat, currentLng) => {
            console.log('📍 Admin: Move Pin clicked:', parkId);
            
            const instructions = `Move ${parkName} pin to new location:\n\nCurrent coordinates: ${currentLat.toFixed(6)}, ${currentLng.toFixed(6)}\n\nEnter new coordinates as: latitude,longitude`;
            const newCoords = prompt(instructions, `${currentLat.toFixed(6)},${currentLng.toFixed(6)}`);
            
            if (!newCoords) return;
            
            const coords = newCoords.split(',').map(c => parseFloat(c.trim()));
            if (coords.length !== 2 || isNaN(coords[0]) || isNaN(coords[1])) {
              toast.error('Invalid coordinates format. Use: latitude,longitude');
              return;
            }
            
            const [newLat, newLng] = coords;
            
            // Call the backend admin endpoint
            axios.patch(`${BACKEND_URL}/api/admin/parks/${parkId}/location`,
              { latitude: newLat, longitude: newLng },
              { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
            ).then(response => {
              toast.success('Park location updated successfully!');
              // Refresh parks to show updated location
              fetchDogParks();
              infoWindowRef.current.close();
            }).catch(error => {
              const message = error.response?.data?.detail || 'Failed to update park location';
              toast.error(message);
            });
          };

          // Subtle random button shivering animation
          window.startButtonShivering = () => {
            const buttons = document.querySelectorAll('.menu-button');
            if (buttons.length === 0) return;
            
            const shiverRandomButton = () => {
              // Random interval between 3-8 seconds
              const nextShiver = Math.random() * 5000 + 3000;
              
              setTimeout(() => {
                // Pick a random button
                const randomIndex = Math.floor(Math.random() * buttons.length);
                const randomButton = buttons[randomIndex];
                
                if (randomButton && document.body.contains(randomButton)) {
                  // Random energy level 1-3
                  const energy = Math.floor(Math.random() * 3) + 1;
                  
                  // Adjust animation duration based on energy
                  const duration = energy === 1 ? '0.4s' : energy === 2 ? '0.6s' : '0.8s';
                  randomButton.style.animationDuration = duration;
                  
                  // Add shiver class
                  randomButton.classList.add('shivering');
                  
                  // Remove class after animation
                  setTimeout(() => {
                    randomButton.classList.remove('shivering');
                  }, parseFloat(duration) * 1000);
                }
                
                // Schedule next shiver if InfoWindow is still open
                if (infoWindowRef.current && infoWindowRef.current.getMap()) {
                  shiverRandomButton();
                }
              }, nextShiver);
            };
            
            // Start the shivering cycle
            shiverRandomButton();
          };

          // Add CSS animations for wooden sign and pulsing button
          const styleSheet = document.createElement('style');
          styleSheet.textContent = `
            @keyframes gentlePulse {
              0%, 100% { 
                box-shadow: 
                  0 4px 15px rgba(16, 185, 129, 0.4),
                  0 0 20px rgba(16, 185, 129, 0.3);
                transform: scale(1);
              }
              50% { 
                box-shadow: 
                  0 6px 25px rgba(16, 185, 129, 0.7),
                  0 0 35px rgba(16, 185, 129, 0.6);
                transform: scale(1.15);
              }
            }
            
            @keyframes strobeHint {
              0%, 100% { 
                opacity: 1;
                transform: translateY(0);
              }
              50% { 
                opacity: 0.6;
                transform: translateY(-3px);
              }
            }
            
            @keyframes fadeInHint {
              from {
                opacity: 0;
                transform: translateY(-10px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
            
            @keyframes socialIconFanIn {
              from {
                opacity: 0;
                transform: translateY(20px) scale(0.5) rotate(-180deg);
              }
              to {
                opacity: 1;
                transform: translateY(0) scale(1) rotate(0deg);
              }
            }
            
            @keyframes subtleShiver {
              0%, 100% { transform: translateX(0px) translateY(0px); }
              10% { transform: translateX(-0.5px) translateY(-0.5px); }
              20% { transform: translateX(0.5px) translateY(0.5px); }
              30% { transform: translateX(-0.3px) translateY(0.3px); }
              40% { transform: translateX(0.3px) translateY(-0.3px); }
              50% { transform: translateX(-0.2px) translateY(-0.2px); }
              60% { transform: translateX(0.2px) translateY(0.2px); }
              70% { transform: translateX(-0.1px) translateY(0.1px); }
              80% { transform: translateX(0.1px) translateY(-0.1px); }
              90% { transform: translateX(0px) translateY(0px); }
            }
            
            .menu-button.shivering {
              animation: subtleShiver 0.6s ease-in-out;
            }
          `;
          document.head.appendChild(styleSheet);

          infoWindowRef.current.setContent(content);
          
          // Enhanced positioning: center above pin, ~10mm above
          const pixelOffset = new window.google.maps.Size(0, -45); // ~10mm above pin
          infoWindowRef.current.setOptions({
            pixelOffset: pixelOffset,
            disableAutoPan: false,
            maxWidth: 650,
            zIndex: 1000 // Ensure info panel is above rating overlays (which have zIndex: 100)
          });
          
          infoWindowRef.current.open(map, marker);
          
          // Start subtle random button shivering after InfoWindow opens
          setTimeout(() => {
            window.startButtonShivering();
          }, 500);
        } catch (error) {
          console.error('Error creating info window:', error);
          // Fallback to simple content
          const fallbackContent = `
            <div style="font-family: 'Space Grotesk', sans-serif; max-width: 300px;">
              <h3>${park.name}</h3>
              <p>${park.description || 'A wonderful place for dog walking!'}</p>
            </div>
          `;
          infoWindowRef.current.setContent(fallbackContent);
          infoWindowRef.current.open(map, marker);
        }
      };

      marker.addListener('click', handleMarkerClick);

      markersRef.current.push(marker);

      // Create rating overlay popup if showRatings is enabled (only for dog parks, not business pins)
      if (showRatingsRef.current && !isBusinessPin) {
        const ratingOverlay = new window.google.maps.InfoWindow({
          content: `
            <style>
              /* Hide the default Google Maps close button */
              .gm-style-iw-c button[aria-label="Close"],
              .gm-style-iw button[aria-label="Close"],
              .gm-ui-hover-effect {
                display: none !important;
              }
              /* Minimize all padding and margins for compact display */
              .gm-style-iw-c {
                padding: 0 !important;
                margin: 0 !important;
                max-width: none !important;
              }
              .gm-style-iw-d {
                overflow: hidden !important;
                padding: 0 !important;
                margin: 0 !important;
              }
              .gm-style-iw-t::after {
                display: none !important;
              }
            </style>
            <div style="
              padding: 3px 6px;
              background: rgba(255, 255, 255, 0.95);
              border: 1px solid rgba(251, 191, 36, 0.4);
              border-radius: 4px;
              box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
              font-family: 'Space Grotesk', sans-serif;
              pointer-events: none;
              user-select: none;
              line-height: 1;
              min-width: 0;
              white-space: nowrap;
            ">
              <div style="
                display: flex;
                align-items: center;
                gap: 2px;
                font-size: 11px;
                font-weight: 600;
                color: #2D4A22;
              ">
                <span style="color: #fbbf24; font-size: 10px;">★</span>
                <span>${park.rating?.toFixed(1) || '0.0'}</span>
              </div>
            </div>
          `,
          disableAutoPan: true,
          pixelOffset: new window.google.maps.Size(0, -45),
          zIndex: 100, // Lower z-index so info panel appears above
        });
        
        // Open the rating overlay immediately
        ratingOverlay.open(map, marker);
        
        // After opening, hide the close button via DOM manipulation as backup
        window.google.maps.event.addListenerOnce(ratingOverlay, 'domready', () => {
          const iwCloseBtn = document.querySelector('.gm-ui-hover-effect');
          if (iwCloseBtn) {
            iwCloseBtn.style.display = 'none';
          }
          // Also minimize the InfoWindow container
          const iwContainer = document.querySelector('.gm-style-iw-c');
          if (iwContainer) {
            iwContainer.style.maxWidth = 'fit-content';
            iwContainer.style.maxHeight = 'fit-content';
          }
        });
        
        // Store reference to close it later
        ratingOverlaysRef.current.push(ratingOverlay);
      }
    });
  }, [map, dogParks, showRatings, specialOffers, user]); // Re-render markers when offers change

  // Search handler
  const handleSearch = async () => {
    if (!searchQuery.trim() || !map) return;

    if (!window.google?.maps?.Geocoder) {
      toast.error('Geocoding not available');
      return;
    }

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: searchQuery }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const location = results[0].geometry.location;
        map.setCenter(location);
        map.setZoom(15);
        toast.success(`Found: ${searchQuery}`);
      } else {
        toast.error('Location not found');
      }
    });
  };

  // Find near me handler
  const findNearMe = () => {
    if (!map) return;

    if (userLocation) {
      map.setCenter(userLocation);
      map.setZoom(15);
      toast.success('Showing locations near you');
    } else {
      toast.loading('Finding your location...', { id: 'geolocation' });
      getCurrentLocation(map);
    }
  };

  // Amenities filter handlers
  const toggleAmenity = (amenityName) => {
    setSelectedAmenities(prev => 
      prev.includes(amenityName)
        ? prev.filter(a => a !== amenityName)
        : [...prev, amenityName]
    );
  };

  const clearAllFilters = () => {
    setSelectedAmenities([]);
    toast.success('Filters cleared');
  };

  return (
    <div className="relative h-screen w-full">
      {/* Sunrise Animation - Every page load welcome */}
      <SunriseAnimation />
      
      {/* Loading Overlay */}
      {isLoading && (
        <div className="absolute inset-0 z-[9999] flex items-center justify-center bg-gradient-to-br from-emerald-50 to-teal-50">
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-emerald-500 mx-auto mb-4"></div>
            <h2 className="text-2xl font-semibold text-gray-700 mb-2">Loading Happy Paws Map</h2>
            <p className="text-gray-500">Finding the best dog walking spots for you...</p>
          </div>
        </div>
      )}
      {/* Header */}
      <div className="absolute top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50 px-2 md:px-4 py-2">
        <div className="flex items-center justify-between max-w-7xl mx-auto gap-2">
          {/* Search Bar - At least 1/3 screen width on mobile */}
          <div className="flex-1 min-w-[33%]">
            <div className="relative">
              <input
                ref={searchInputRef}
                type="text"
                placeholder="Search location..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                className="w-full px-3 py-2 pr-9 border border-gray-300 rounded-full focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-sm"
              />
              <button
                onClick={handleSearch}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-emerald-600"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </button>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex space-x-1 md:space-x-2 flex-shrink-0">
            <button
              onClick={() => setShowFilterModal(true)}
              title="Filter by amenities"
              aria-label="Filter by amenities"
              className={`${selectedAmenities.length > 0 ? 'bg-purple-600 hover:bg-purple-700' : 'bg-gray-600 hover:bg-gray-700'} text-white px-2 py-2 md:px-3 md:py-2 rounded-full font-medium transition-all duration-200 flex items-center justify-center space-x-1 text-xs md:text-sm shadow-lg whitespace-nowrap relative group hover:scale-105`}
            >
              <span>🔍</span><span className="hidden sm:inline">Filter</span>
              {selectedAmenities.length > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  {selectedAmenities.length}
                </span>
              )}
              <span className="absolute bottom-full mb-2 hidden group-hover:block bg-gray-900 text-white text-xs rounded py-1 px-2 whitespace-nowrap sm:hidden pointer-events-none">
                Filter
              </span>
            </button>
            <button
              onClick={() => {
                if (isAuthenticated) {
                  setShowAddLocationModal(true);
                } else {
                  setShowRedirectModal(true);
                }
              }}
              title="Add new dog park location"
              aria-label="Add new dog park location"
              className="bg-blue-600 hover:bg-blue-700 text-white px-2 py-2 md:px-3 md:py-2 rounded-full font-medium transition-all duration-200 flex items-center justify-center space-x-1 text-xs md:text-sm shadow-lg whitespace-nowrap relative group hover:scale-105"
            >
              <span>📍</span><span className="hidden sm:inline">Add Location</span>
              <span className="absolute bottom-full mb-2 hidden group-hover:block bg-gray-900 text-white text-xs rounded py-1 px-2 whitespace-nowrap sm:hidden pointer-events-none">
                Add Location
              </span>
            </button>
            <button
              onClick={() => window.location.href = '/dashboard'}
              title="Go to your dashboard"
              aria-label="Go to your dashboard"
              className="bg-amber-600 hover:bg-amber-700 text-white px-2 py-2 md:px-3 md:py-2 rounded-full font-medium transition-all duration-200 flex items-center justify-center space-x-1 text-xs md:text-sm shadow-lg whitespace-nowrap relative group hover:scale-105"
            >
              <span>🏠</span><span className="hidden sm:inline">Dashboard</span>
              <span className="absolute bottom-full mb-2 hidden group-hover:block bg-gray-900 text-white text-xs rounded py-1 px-2 whitespace-nowrap sm:hidden pointer-events-none">
                Dashboard
              </span>
            </button>
            <button
              onClick={findNearMe}
              title="Center map on your location"
              aria-label="Center map on your location"
              className="bg-emerald-500 hover:bg-emerald-600 text-white px-2 py-2 md:px-3 md:py-2 rounded-full font-medium transition-all duration-200 flex items-center justify-center space-x-1 text-xs md:text-sm shadow-lg whitespace-nowrap relative group hover:scale-105"
            >
              <span>📍</span><span className="hidden sm:inline">Near</span>
              <span className="absolute bottom-full mb-2 hidden group-hover:block bg-gray-900 text-white text-xs rounded py-1 px-2 whitespace-nowrap sm:hidden pointer-events-none">
                Near Me
              </span>
            </button>
          </div>
        </div>

        {/* Active Filter Chips */}
        {selectedAmenities.length > 0 && (
          <div className="max-w-7xl mx-auto mt-2 px-2 md:px-4">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="text-xs text-gray-600">Filters:</span>
              {selectedAmenities.map(amenity => (
                <span
                  key={amenity}
                  className="inline-flex items-center gap-1 px-2 py-1 bg-purple-100 text-purple-700 rounded-full text-xs"
                >
                  {availableAmenities.find(a => a.name === amenity)?.icon} {amenity}
                  <button
                    onClick={() => toggleAmenity(amenity)}
                    className="hover:text-purple-900"
                  >
                    ×
                  </button>
                </span>
              ))}
              <button
                onClick={clearAllFilters}
                className="text-xs text-red-600 hover:text-red-800 underline"
              >
                Clear all
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Map Container */}
      <div
        ref={mapContainerRef}
        className="w-full h-full pt-16"
        style={{ minHeight: '400px' }}
      />

      {/* Show Ratings Toggle - Sleeker Design */}
      <div className="absolute bottom-20 left-6 bg-white/95 backdrop-blur-sm rounded-full px-3 py-1.5 shadow-lg border border-gray-200">
        <label className="flex items-center space-x-2 cursor-pointer">
          <input
            type="checkbox"
            checked={showRatings}
            onChange={(e) => setShowRatings(e.target.checked)}
            className="rounded border-gray-300 text-emerald-500 focus:ring-emerald-500 w-4 h-4"
          />
          <span className="text-sm font-medium text-gray-700 whitespace-nowrap">⭐ Show Ratings</span>
        </label>
      </div>

      {/* Add Location Modal */}
      {showAddLocationModal && (
        <AddLocationModal
          isOpen={showAddLocationModal}
          onClose={() => {
            setShowAddLocationModal(false);
            loadDogParks(); // Refresh parks after adding
          }}
          onAuthRequired={() => setShowRedirectModal(true)}
          initialMapCenter={getCurrentMapCenter()}
          initialMapZoom={getCurrentMapZoom()}
          openDirectToMapPicker={true}
        />
      )}

      {/* Rating Modal */}
      {showRatingModal && selectedParkForRating && (
        <RatingModal
          isOpen={showRatingModal}
          onClose={() => {
            setShowRatingModal(false);
            setSelectedParkForRating(null);
          }}
          preselectedParkId={selectedParkForRating.id}
          park={selectedParkForRating}
          onRatingAdded={() => {
            loadDogParks(); // Refresh parks after rating
          }}
          onAuthRequired={() => setShowRedirectModal(true)}
        />
      )}

      {/* Comments Modal */}
      {showCommentsModal && selectedParkForComments && (
        <CommentsModal
          isOpen={showCommentsModal}
          onClose={() => {
            setShowCommentsModal(false);
            setSelectedParkForComments(null);
          }}
          parkId={selectedParkForComments.id}
          parkName={selectedParkForComments.name}
        />
      )}

      {/* Special Offer Modal - For Both Admin and Regular Users */}
      {showOfferModal && selectedOffer && selectedParkForOffer && (
        <SpecialOfferModal
          offer={selectedOffer}
          parkName={selectedParkForOffer.name}
          isAdmin={user && (user.role === 'admin' || user.role === 'master')}
          onEditClick={() => {
            setShowOfferModal(false);
            setShowOfferForm(true);
            // selectedParkForOffer and selectedOffer are already set
          }}
          onClose={() => {
            setShowOfferModal(false);
            setSelectedOffer(null);
            setSelectedParkForOffer(null);
          }}
        />
      )}

      {/* Admin Offer Menu - DEPRECATED - Now using unified SpecialOfferModal flow */}
      {/* AdminOfferMenu removed - Admin clicks offer → SpecialOfferModal with edit button → SpecialOfferForm */}

      {/* Special Offer Form - Admin Create/Edit */}
      {showOfferForm && selectedParkForOffer && (
        <SpecialOfferForm
          park={selectedParkForOffer}
          existingOffer={specialOffers.find(o => o.park_id === selectedParkForOffer.id)}
          onClose={() => {
            setShowOfferForm(false);
            setSelectedParkForOffer(null);
          }}
          onSuccess={async () => {
            const currentParkId = selectedParkForOffer?.id;
            setShowOfferForm(false);
            setSelectedParkForOffer(null);
            
            // Fetch updated offers
            try {
              const res = await axios.get(`${API}/special-offers`);
              const updatedOffers = res.data.offers || [];
              setSpecialOffers(updatedOffers);
              
              // If the modal is currently showing an offer for this park, update it
              if (showOfferModal && selectedOffer && currentParkId) {
                const updatedOffer = updatedOffers.find(o => o.park_id === currentParkId);
                if (updatedOffer) {
                  setSelectedOffer(updatedOffer);
                  console.log('✅ Offer modal updated with fresh data');
                }
              }
              
              console.log('✅ Offers refreshed without page reload');
            } catch (error) {
              console.error('Failed to refresh offers:', error);
              toast.error('Offer saved but failed to refresh. Please reload the page.');
            }
          }}
          onManageClick={() => {
            setShowOfferForm(false);
            setShowOfferManagement(true);
          }}
        />
      )}

      {/* Offer List Management - Admin */}
      {showOfferManagement && selectedParkForOffer && (
        <OfferListManagement
          park={selectedParkForOffer}
          onClose={() => {
            setShowOfferManagement(false);
            setSelectedParkForOffer(null);
          }}
          onSuccess={async () => {
            // Refresh offers without page reload
            try {
              const res = await axios.get(`${API}/special-offers`);
              const updatedOffers = res.data.offers || [];
              setSpecialOffers(updatedOffers);
              console.log('✅ Offers refreshed without page reload');
            } catch (error) {
              console.error('Failed to refresh offers:', error);
              toast.error('Failed to refresh offers. Please reload the page.');
            }
          }}
        />
      )}

      {/* Business Template Editor - Admin (NEW SIMPLIFIED FLOW) */}
      {showBusinessTemplateEditor && selectedBusinessPark && (
        <BusinessTemplateEditor
          park={selectedBusinessPark}
          existingOffer={specialOffers.find(o => o.park_id === selectedBusinessPark.id)}
          onClose={() => {
            setShowBusinessTemplateEditor(false);
            setSelectedBusinessPark(null);
          }}
          onSave={async () => {
            try {
              // Small delay to ensure DB transaction completes
              await new Promise(resolve => setTimeout(resolve, 300));
              
              // Refresh offers from API
              const response = await axios.get(`${API}/special-offers`);
              setSpecialOffers(response.data.offers || []);
              
              console.log('✅ Offers refreshed after save:', response.data.offers?.length);
              
              // useEffect with specialOffers dependency will auto re-render markers
              toast.success('Offer saved and map updated!');
            } catch (error) {
              console.error('Error refreshing offers:', error);
              toast.error('Offer saved but failed to refresh. Please reload the page.');
            }
          }}
        />
      )}

      {/* Redirect to Register Modal */}
      <RedirectToRegisterModal
        isOpen={showRedirectModal}
        onClose={() => setShowRedirectModal(false)}
        onLoginClick={() => {
          setShowRedirectModal(false);
          // Trigger a click on a hidden AuthModal trigger
          setTimeout(() => {
            document.getElementById('map-auth-trigger')?.click();
          }, 100);
        }}
      />

      {/* Hidden Auth Modal Trigger - Opens with Register tab */}
      <AuthModal defaultTab="register">
        <button id="map-auth-trigger" style={{ display: 'none' }} />
      </AuthModal>

      {/* Amenities Filter Modal */}
      {showFilterModal && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-50"
            onClick={() => setShowFilterModal(false)}
          />
          
          {/* Bottom Sheet Modal */}
          <div className="fixed inset-x-0 bottom-0 z-50 bg-white rounded-t-3xl shadow-2xl max-h-[80vh] overflow-y-auto animate-slide-up">
            <div className="p-6">
              {/* Header */}
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-bold text-gray-800">Filter by Amenities</h3>
                <button
                  onClick={() => setShowFilterModal(false)}
                  className="text-gray-400 hover:text-gray-600 text-2xl"
                >
                  ×
                </button>
              </div>

              {/* Results count */}
              <div className="mb-4 text-sm text-gray-600">
                {dogParks.length} {dogParks.length === 1 ? 'park' : 'parks'} found
              </div>

              {/* Amenities Grid */}
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-6">
                {availableAmenities.map((amenity) => (
                  <button
                    key={amenity.name}
                    onClick={() => toggleAmenity(amenity.name)}
                    className={`flex items-center gap-2 p-3 rounded-lg border-2 transition-all ${
                      selectedAmenities.includes(amenity.name)
                        ? 'border-purple-500 bg-purple-50 text-purple-700'
                        : 'border-gray-200 hover:border-gray-300 text-gray-700'
                    }`}
                  >
                    <span className="text-2xl">{amenity.icon}</span>
                    <span className="text-sm font-medium">{amenity.name}</span>
                    {selectedAmenities.includes(amenity.name) && (
                      <span className="ml-auto text-purple-500">✓</span>
                    )}
                  </button>
                ))}
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3">
                <button
                  onClick={clearAllFilters}
                  className="flex-1 px-4 py-3 border-2 border-gray-300 text-gray-700 rounded-full font-medium hover:bg-gray-50 transition-colors"
                >
                  Clear All
                </button>
                <button
                  onClick={() => setShowFilterModal(false)}
                  className="flex-1 px-4 py-3 bg-purple-600 text-white rounded-full font-medium hover:bg-purple-700 transition-colors"
                >
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default MapPage;
